var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwittericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 34,
    viewBox: "0 0 40 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5836 33.25C27.6742 33.25 35.9305 20.7445 35.9305 9.9031C35.9305 9.55154 35.9227 9.19216 35.907 8.8406C37.5131 7.6791 38.8992 6.24042 40 4.59216C38.5042 5.25767 36.9161 5.6923 35.2898 5.88123C37.0021 4.85485 38.2842 3.24245 38.8984 1.34294C37.2876 2.2976 35.526 2.97102 33.6891 3.33435C32.4514 2.01927 30.815 1.14853 29.0328 0.856752C27.2506 0.564976 25.422 0.868417 23.8296 1.72016C22.2372 2.5719 20.9697 3.92451 20.2231 5.56885C19.4765 7.2132 19.2924 9.05769 19.6992 10.8172C16.4375 10.6535 13.2466 9.80617 10.3333 8.33016C7.42004 6.85415 4.84949 4.78239 2.78828 2.24919C1.74067 4.05541 1.42009 6.19274 1.89172 8.22682C2.36334 10.2609 3.59177 12.0391 5.32734 13.2C4.02438 13.1586 2.74996 12.8078 1.60938 12.1765V12.2781C1.60821 14.1736 2.2635 16.011 3.46385 17.4779C4.6642 18.9449 6.33554 19.9509 8.19375 20.325C6.98676 20.6552 5.71997 20.7033 4.49141 20.4656C5.01576 22.0957 6.03595 23.5215 7.40962 24.5439C8.78328 25.5663 10.4419 26.1343 12.1539 26.1687C9.24737 28.4518 5.65696 29.6902 1.96094 29.6844C1.30548 29.6833 0.650665 29.6432 0 29.564C3.75476 31.9729 8.12255 33.2523 12.5836 33.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwittericon);
export default __webpack_public_path__ + "static/media/twitter icon.7667e2a39f0dc5809255d933a369afad.svg";
export { ForwardRef as ReactComponent };